(function () {

  'use strict';

  function pxSecureSettings(
    PrintQueueListPaging, URLS, URL_PARAMS, $location, PrintQueueListService, PrinterListPOSTPaging,
    PrinterListService, GroupListService, $timeout, toastr, $filter, TenantListService,
    $rootScope, EventServiceEvents, $q, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me'
      },
      templateUrl: 'app/components/settings/secureSettings/secureSettings.template.html',
      link: function (scope) {

        scope.disableMustPrintLater = false;
        scope.securePrintIsEnabled = null;
        scope.anywherePrinter = null;
        scope.updatingSecuritySettings = false;
        scope.saveChangesSecuritySettingsTimer = undefined;
        scope.toggleSecurePrintTimer = undefined;
        scope.disableSecurePrintCheckbox = false;

        scope.printQueuePaginationObject = new PrintQueueListPaging();
        scope.printerListPaging = new PrinterListPOSTPaging();

        (function () {
          scope.groupsEnabled = scope.tenant.info.groupsEnabled;
          setSecureSettings();
          checkSecuritySettings();
          getAnywhereQueues();
          setListeners();
          checkInstallOndeviceSetting();
        })();

        function checkInstallOndeviceSetting() {
          scope.enableOnDevice = scope.tenant.info.enableOnDevice;
          const goDisableContent = $filter('translate')('PrintixGoEnableOnDeviceText').replace(/<\/br\s*[\/]?>/gi, '');
          scope.goDisableContentFormated = $filter('translate')(goDisableContent);
        }

        function setSecureSettings() {
          if (scope.tenant.info._embedded.securePrintConfiguration) {
            scope.secureSettingsInterface = {
              mustPrintSecurely: !!scope.tenant.info._embedded.securePrintConfiguration.mustPrintSecurely,
              printLaterByDefault: !!scope.tenant.info._embedded.securePrintConfiguration.printLaterByDefault
            };
          } else {
            scope.secureSettingsInterface = {
              mustPrintSecurely: null,
              printLaterByDefault: null
            };
          }
        }

        function getAnywhereQueues() {
          scope.printQueuePaginationObject.pagingCriteria.printerTypes = ['FREEDOM'];
          if (scope.tenant.info._embedded.productsAndFeatures.features.SECURE_PRINT.enabled && scope.tenant.info._embedded.securePrintConfiguration && scope.tenant.info._embedded.securePrintConfiguration.enablePrintAnywhere) {
            PrintQueueListService.getPrintQueueListPaged(scope.printQueuePaginationObject).then(function (response) {
              scope.anywhereQueues = response.list;
              scope.anywereQueuesCount = response.page.totalElements;
            }).catch(function () {});
          }

          scope.printerListPaging.pagingCriteria.matchVendorModel = ['PRINTIX'];
          PrinterListService.getPrinterListPaged(scope.printerListPaging).then(function (response) {
            if (response.list.length) {
              scope.anywherePrinter = response.list[0];
            } else {
              PrinterListService.createPrinter({ name: 'Printix Anywhere', type: 'FREEDOM' }).then(function () {
                getAnywhereQueues();
              }).catch(function () {});
            }
          }).catch(function () {});
        }

        scope.saveChangesSecuritySettings = function (anywhere) {
          scope.tenant.info._embedded.securePrintConfiguration.mustPrintSecurely = scope.secureSettingsInterface.mustPrintSecurely;
          scope.tenant.info._embedded.securePrintConfiguration.printLaterByDefault = scope.secureSettingsInterface.printLaterByDefault;
          scope.updatingSecuritySettings = true;
          scope.saveChangesSecuritySettingsTimer = $timeout(function () {
            executeSaveChangesSecuritySettings(anywhere);
          }, 1000);
        };

        function executeSaveChangesSecuritySettings(anywhere) {
          const url = scope.tenant.info._embedded.securePrintConfiguration._links.self.href;
          TenantListService.currentTenant.saveChangesSecuritySettings(url, scope.tenant).then(function () {
            scope.updatingSecuritySettings = false;
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function () {});
        }

        scope.toggleSecurePrint = function (reverse) {
          scope.disableSecurePrintCheckbox = true;
          if (reverse) {
            scope.tenant.info._embedded.productsAndFeatures.features.SECURE_PRINT.enabled = !scope.tenant.info._embedded.productsAndFeatures.features.SECURE_PRINT.enabled;
          }
          scope.toggleSecurePrintTimer = $timeout(function () {
            executeToggleSecurePrint();
          }, 1000);
        };

        function executeToggleSecurePrint() {
          const url = scope.tenant.info._embedded.productsAndFeatures._links.self.href;
          scope.tenant.toggleSecurePrint(url, scope.tenant).then(function (response) {
            $http.get(TenantListService.tenantUrl).then(function (tenantRaw) {
              scope.disableSecurePrintCheckbox = false;
              scope.tenant.info = tenantRaw.data;
              scope.anywhereQueues = [];
              setSecureSettings();
              getAnywhereQueues();
              checkSecuritySettings();
            }).catch(function () {});
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function () {});
        }

        function checkSecuritySettings() {
          if (scope.tenant.info._embedded.productsAndFeatures.features.SECURE_PRINT.enabled) {
            scope.securePrintIsEnabled = true;
            if (scope.tenant.info._embedded.securePrintConfiguration) {
              const embedded = scope.tenant.info._embedded.securePrintConfiguration._embedded;
              scope.disableMustPrintLater = false;
              if (embedded.mustPrintSecurelyGroup.length > 0) {
                scope.tenant.info._embedded.securePrintConfiguration.mustPrintSecurelyGroups = true;
                scope.disableMustPrintLater = true;
              }

              if (embedded.printLaterByDefaultGroup.length > 0) {
                scope.tenant.info._embedded.securePrintConfiguration.printLaterByDefaultGroups = true;
                scope.disableMustPrintLater = true;
              }

              if (scope.tenant.info._embedded.securePrintConfiguration.printLaterByDefault) {
                scope.disableMustPrintLater = true;
              }
            }
          } else {
            scope.securePrintIsEnabled = false;
          }
        }

        scope.patchAuthenticationConfiguration = function (path, value) {
          scope.tenant.patchUserSecretAuthenticationConfig(path, value).then(function (response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function () {
            toastr.success($filter('translate')('ERROR'));
          });
        };

        /// ////////////////////////////////////
        /// /// TOOLTIPS
        /// ////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch (tooltipScope) {
              case 'site':
                siteTooltip(position, context);
                break;
              case 'securelyGroups':
                securelyGroupsTooltip(position, context);
                break;
              case 'printLaterByDefaultGroup':
                printLaterByDefaultGroupTooltip(position, context);
                break;
              case 'anywhereQueues':
                anywhereQueuesTooltip(position, context);
                break;
              case 'listTooltip':
                listTooltip(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function siteTooltip(position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title,
            type: 'statement'
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        function listTooltip(position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.title,
            type: 'listTooltip',
            list: context.list,
            totalElements: context.list.length
          };

          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        function securelyGroupsTooltip(position) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'MustPrintSecurelyGroups',
            type: 'listTooltip',
            list: scope.tenant.info._embedded.securePrintConfiguration._embedded.mustPrintSecurelyGroup,
            totalElements: scope.tenant.info._embedded.securePrintConfiguration._embedded.mustPrintSecurelyGroup.length
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: false
          };
        }

        function printLaterByDefaultGroupTooltip(position) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'PrintLaterByDefaultGroups',
            type: 'listTooltip',
            list: scope.tenant.info._embedded.securePrintConfiguration._embedded.printLaterByDefaultGroup,
            totalElements: scope.tenant.info._embedded.securePrintConfiguration._embedded.printLaterByDefaultGroup.length
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: false
          };
        }

        function anywhereQueuesTooltip(position) {

          const simpleList = [];
          angular.forEach(scope.anywhereQueues, function (anywereQueue) {
            const simpleQueue = {
              name: anywereQueue.info.name
            };
            simpleList.push(simpleQueue);
          });

          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'PrintAnywhere',
            type: 'listTooltip',
            list: simpleList,
            totalElements: scope.anywereQueuesCount
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: false
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

        /// ////////////////////////////////////
        /// /// NEW CONTEXT MENUS
        /// ////////////////////////////////////
        scope.openContextMenu = function (event, context, menuOption) {

          $timeout(function  () {
            if (event && context && menuOption) {
              scope.selectedContextMenuItem  =  menuOption;
              scope.contextPosition = { left: event.clientX, top: event.clientY };
              scope.context = context;
              scope.resource = scope.tenant;
              scope.auxiliaries = {
                me: scope.me
              };
            } else {
              scope.selectedContextMenuItem  =  null;
              scope.contextPosition = null;
              scope.context = null;
            }
          }, 50);
        };

        scope.closeAllMenues = function (newContext) {

          if (newContext) {
            if (angular.equals(scope.context, newContext)) {
              scope.selectedContextMenuItem  =  null;
              scope.contextPosition = null;
              scope.context = null;
            } else {
              openNewContext(newContext);
            }
          } else {
            scope.selectedContextMenuItem  =  null;
            scope.contextPosition = null;
            scope.context = null;
          }
        };

        function openNewContext(newContext) {
          scope.openContextMenu(newContext.event, newContext, { type: newContext.type, title: newContext.title });
        }

        /// /////////////////////////////////
        /// /////////////////////////////////
        /// ///  Open context menu
        /// /////////////////////////////////
        scope.openListMenu = function (event, context) {

          let menuItems = null;
          let icon = null;
          switch (context.type) {
            case 'groupMenu':
              menuItems = [
                { title: 'Groups', selected: false, type: 'showSecureGroupList', breaker: false },
                { title: 'AddGroups', selected: false, type: 'addSecureGroups', breaker: false, bypassCloseOutside: true, disabled: scope.me.isSystemObserver() },
                { title: 'RemoveGroups', selected: false, type: 'removeSecureGroups', breaker: true, disabled: scope.me.isSystemObserver() }
              ];
              icon = 'icon-group';
              break;
            case 'queueMenu':
              menuItems = [
                { title: 'PrintQueues', selected: false, type: 'showAnywhereQueues', breaker: false },
                { title: 'CreatePrintQueue', selected: false, type: 'createAnywhereQueue', breaker: false, disabled: scope.me.isSystemObserver() }
              ];
              icon = 'icon-paper-tray-2';
              break;
          }

          context.name = $filter('translate')(context.name);

          scope.closeAllMenues();

          $timeout(function () {
            scope.menuContent = {
              menuItems,
              context,
              icon,
              sizeClass: 'size115',
              type: 'ALLROUND'
            };
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'ALLROUND'
            };
          }, 50);
        };

        scope.closeMenu = function (selection, position, content) {
          if (selection) {
            scope.openContextMenu({ clientX: position.left, clientY: position.top }, content.context, selection);
          }
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.contextContent = null;
        };

        /// ////////////////////////////////////
        /// /// LISTENERS
        /// ////////////////////////////////////
        function setListeners() {

        }

        const SECURE_PRINT_CONFIGURATION_UPDATED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SECURE_PRINT_CONFIGURATION_UPDATED, function (name, data) {
          $http.get(data.securePrintConfiguration).then(function (response) {
            scope.tenant.info._embedded.securePrintConfiguration = response.data;
          }).catch(function () {});
        });

        const PRINTER_UPDATE_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function (name, data) {
          if (scope.anywherePrinter.length > 0) {
            if (scope.anywherePrinter.info._links.self.href === data.printer) {
              getAnywhereQueues();
            }
          }
        });

        const PRINT_QUEUE_REMOVED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_REMOVED, function (name, data) {
          const removedPrintQueue = data.printQueue;
          for (let i = 0; i < scope.anywhereQueues.length; i++) {
            if (scope.anywhereQueues[i].info._links.self.href === removedPrintQueue) {
              getAnywhereQueues();
              break;
            }
          }
        });

        const PRINT_QUEUE_ADDED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_ADDED, function (name, data) {
          const anywherePrinter = data.printer;
          if (scope.anywherePrinter.info._links.self.href === anywherePrinter) {
            getAnywhereQueues();
          }
        });

        const PRINT_QUEUE_UPDATED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_UPDATED, function (name, data) {
          const anywherePrinter = data.printer;
          if (scope.anywherePrinter.info._links.self.href === anywherePrinter) {
            getAnywhereQueues();
          }
        });

        scope.$on('$destroy', function () {
          SECURE_PRINT_CONFIGURATION_UPDATED_listener();
          PRINTER_UPDATE_listener();
          PRINT_QUEUE_REMOVED_listener();
          PRINT_QUEUE_ADDED_listener();
          PRINT_QUEUE_UPDATED_listener();
        });

      }
    };
  }

  pxSecureSettings.$inject = [
    'PrintQueueListPaging', 'URLS', 'URL_PARAMS', '$location', 'PrintQueueListService', 'PrinterListPOSTPaging',
    'PrinterListService', 'GroupListService', '$timeout', 'toastr', '$filter', 'TenantListService',
    '$rootScope', 'EventServiceEvents', '$q', '$http'
  ];

  angular
    .module('printix-admin')
    .directive('pxSecureSettings', pxSecureSettings);

})();
